/**
 * THE CONTRACT'S SERVERS. SwaggerHub `pharmos-api` 1.0.0, stored in
 * `openapi/pharmos-api.yaml`. Paths in the client start at `/v1/`, so the
 * base is the host plus `/api` and nothing after it.
 *
 * A build talks to one of them. Dev is the one used when `VITE_API_BASE_URL`
 * is unset (`api/config.ts`). UAT and production are that variable.
 */
export const API_SERVERS = [
  "https://dev.pharmos.pcfhk.org/api",
  "https://uat.pharmos.pcfhk.org/api",
  "https://pharmos.pcfhk.org/api",
] as const;

export const DEFAULT_API_BASE_URL = API_SERVERS[0];
